module.exports = __webpack_public_path__ + "static/media/mastercard-logo.b07c1e0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mastercard-logo.svg
// module id = 750
// module chunks = 0